import { toast } from 'react-toastify';

export const styleConstants = {
    GOTHAM_MEDIUM: 'Gotham Medium',
    COLORS: {
        WHITE: '#ffffff',
        BLACK_LOW: '#222222',
        BLACK_DEEP: '#191919',
        RED: '#c50119',
        BLACK_LIGHT: '#9d9d9c',
        LIGHT_GREY: 'lightgrey',
    },
    TOAST_OPTIONS: { position: toast.POSITION.BOTTOM_RIGHT },
    TEXT_FIELD_LIMIT: 256,
};
